exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".hover-reveal[data-v-9868830e] {\n  transition: all 0.3s;\n  z-index: 2;\n  opacity: 0;\n}\n.hover-reveal[data-v-9868830e]:hover {\n  opacity: 1;\n}\n.hover-reveal:hover + .hover-50[data-v-9868830e] {\n  transition: all 0.3s;\n  opacity: 0.5;\n}", ""]);

// exports
